export default __webpack_public_path__ + "static/media/img03.b77beaea.svg";